module.exports = __webpack_public_path__ + "static/media/doc-logo.8a46d656.svg";